// Rewards Earn & Spend - Scroll Progress Bar

// Function to initialize the scroll progress bar
function initRewardsEarnSpendProgress() {
  const timelineEl = document.querySelector('.rewards-earn-spend__timeline-progress');
  const sectionEl = document.querySelector('.rewards-earn-spend');
  
  if (!timelineEl || !sectionEl) return;
  
  // Set initial height to 0%
  timelineEl.style.height = '0%';
  
  // Throttle function to limit execution frequency
  function throttle(callback, delay) {
    let lastCall = 0;
    return function() {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      callback.apply(this, arguments);
    };
  }
  
  // Track previous scroll position to determine direction
  let lastScrollTop = 0;
  
  // Function to update progress bar based on scroll position
  function updateProgressBar() {
    // Get section position relative to viewport
    const rect = sectionEl.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Calculate how much of the section is visible
    // Start when the top of the section enters the bottom of the viewport
    // End when the bottom of the section leaves the top of the viewport
    let start = windowHeight;
    let end = windowHeight + rect.height;
    let current = windowHeight - rect.top;
    
    // Calculate progress percentage (0 to 100)
    let progress = Math.max(0, Math.min(100, (current / (end - start)) * 100));
    
    // Determine scroll direction
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isScrollingDown = currentScrollTop > lastScrollTop;
    lastScrollTop = currentScrollTop;
    
    if (isScrollingDown) {
      // Add delay only when scrolling down for visual effect
      setTimeout(() => {
        timelineEl.style.height = `${progress}%`;
      }, 50);
    } else {
      // No delay when scrolling up for immediate response
      timelineEl.style.height = `${progress}%`;
    }
  }
  
  // Throttle the scroll event to improve performance and make animation more visible
  const throttledUpdateProgressBar = throttle(updateProgressBar, 100);
  
  // Update on scroll with throttling
  window.addEventListener('scroll', throttledUpdateProgressBar, { passive: true });
  
  // Initial update with a small delay to ensure elements are properly rendered
  setTimeout(updateProgressBar, 200);
  
  // Update on window resize with throttling
  window.addEventListener('resize', throttledUpdateProgressBar, { passive: true });
  
  console.log('Rewards Earn & Spend progress bar initialized');
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  initRewardsEarnSpendProgress();
});

// Initialize when Shopify section is loaded or reloaded
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('rewards-earn-spend')) {
    initRewardsEarnSpendProgress();
  }
});

// Initialize immediately if DOM is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(initRewardsEarnSpendProgress, 1);
}